import React, {Component} from "react";
import {monthOptions, yearOptions} from "../config";
import {configMonthToDateByTL} from "./config";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { HttpStatus } from "../../../../common/Constants";
import * as R from "ramda";
class MonthToDateSalesReportByTL extends Component {
    constructor(props) {
        super(props);
        const currentDate = new Date();
        this.state = {
            month: monthOptions.find(
              (item) => item.value === currentDate.getMonth() + 1
            ),
            year: yearOptions.find(item => item.value === currentDate.getFullYear()),
            tableConfig: configMonthToDateByTL,
            dataTable: [],
        };
    };

    componentDidMount() {
        this.handleSearch();
    };

    componentDidUpdate(prevProps, prevState) { 
        if(!R.equals(prevProps.doSearch, this.props.doSearch) && this.props.doSearch){
            this.handleSearch();
        }
    } 

    handleChangeSearchValue = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            [name]: value,
        }));
    };

    transformResponseToTable = (data) => {
      return [
        ...data.data,
        {
          name: "Total",
          lastMonth: data.totalLastMonth,
          thisMonth: data.totalThisMonth,
          growth: data.growth,
          forecasting: data.totalForecasting,
        },
      ];
    }

    fetchData = async () => {
        this.props.triggerLoading()
        const res = await fetchDataAsync({
          asyncFn:
            Api.create("NAGAMAS_REPORT_DTO").getLaporanJualanMTDSalesmanCS,
          setError: this.props.setError,
          menuName:
            "Dashboard Level Kacab - Laporan Jualan MTD Salesman CS",
          args: {
            kodeCabang: [this.props.kodeCabang.value],
            year: this.state.year?.value,
            month: this.state.month?.value,
            mode: "LEADER",
            idLeader: this.props.idLeader,
          },
        });
        this.props.onSuccessSearch();
        this.props.triggerLoading()
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
          this.setState((prevValue) => ({
            ...prevValue,
            dataTable: this.transformResponseToTable(res.data.data),
          }));
        }
    };

    handleSearch = () =>{
        this.fetchData();
    }

    render() {
        return(
            <>
                <FlexView style={{gap: "20px", alignItems: "center"}}>
                    <SimpleDDL
                        isClearable
                        id="select_options_month"
                        box="search"
                        name="month"
                        containerclassname="width width-250px"
                        placeholder="Bulan"
                        menuPosition="fixed"
                        options={monthOptions}
                        value={this.state.month}
                        onChange={(value, {name}) => this.handleChangeSearchValue(name, value)}
                    />
                    <SimpleDDL
                        isClearable
                        id="select_options_year"
                        box="search"
                        name="year"
                        containerclassname="width width-250px"
                        placeholder="Tahun"
                        menuPosition="fixed"
                        options={yearOptions}
                        value={this.state.year}
                        onChange={(value, {name}) => this.handleChangeSearchValue(name, value)}
                    />
                    <SimpleButton
                        styles={{marginBottom: "15px"}}
                        onClick={()=>this.handleSearch()}
                    >Cari</SimpleButton>
                </FlexView>
                <SimpleDataTable
                    data={this.state.dataTable}
                    columns={this.state.tableConfig}
                />
            </>
        );
    };
}

export default MonthToDateSalesReportByTL;